
import { mapState, mapGetters } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel },
  data() {
    return {
      selected: "orders",
      items: [
        { value: "orders", label: "Orders" },
        { value: "revenue", label: "Revenue" },
        { value: "item", label: "Item" },
        { value: "cancellation", label: "Cancellation" }
      ],
      series: [],
      chartOptions: {
        colors: [
          "#FF7D47",
          "#FFD831",
          "#47CFFF",
          "#9244FF",
          "#20D648",
          "4B47FF"
        ],
        chart: {
          type: "pie",
          width: "500px",
          height: "400px"
        },
        labels: [],
        legend: {
          // show: false,
          position: "bottom",
          horizontalAlign: "left",
          fontSize: "10px",
          offsetY: "10",
          height: "25"
        },

        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
          style: {
            fontSize: "12px",
            textTransform: "capitalize",
            offset: "-10px"
          }
        }
      }
    };
  },
  mounted() {
    this.selectionChange();
  },
  computed: {
    ...mapGetters("report", ["getChannels"]),
    ...mapState("report", ["summary"])
  },
  watch: {
    summary() {
      this.selectionChange();
    }
  },
  methods: {
    selectionChange() {
      this.series = [];
      this.chartOptions.labels = [...this.getChannels];
      this.$nextTick(() => {
        this.getChannels.forEach(
          ((channel) => {
            let data = 0;
            if (this.selected == "orders") {
              data =
                this.summary.find((el) => el.channel == channel)?.count || 0;
            } else if (this.selected == "revenue") {
              data =
                this.summary.find((el) => el.channel == channel)
                  ?.merchant_receivable_amount || 0;
            } else if (this.selected == "item") {
              data =
                this.summary.find((el) => el.channel == channel)
                  ?.order_items_count || 0;
            } else if (this.selected == "cancellation") {
              data =
                this.summary.find((el) => el.channel == channel)
                  ?.cancelled_orders_count || 0;
            }
            this.series.push(Math.round(data));
          }).bind(this)
        );
      });
    }
  }
};
